(ns teamoesterreich.user-mode.profile.profile-options
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.description :refer [description]]


    [reagent-material-ui.icons.devices :refer [devices]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.event :refer [event]]


    [reagent-material-ui.icons.info :refer [info]]
    [reagent-material-ui.icons.lock :refer [lock]]
    [reagent-material-ui.icons.notifications :refer [notifications]]
    [reagent-material-ui.icons.person :refer [person]]
    [reagent-material-ui.icons.rowing :refer [rowing]]
    [reagent-material-ui.icons.warning-two-tone :refer [warning-two-tone]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.navigation.bottom-bar :as bottom-bar]
    ))

(defn set-profile-page [sub-page]
  (let [actual-page (get @store/app-state :site)]
    (a/set-page
      (cond
        (and (= actual-page :profile) (= sub-page :personal)) :profile-personal
        (and (= actual-page :profile) (= sub-page :qualifications)) :profile-qualifications
        (and (= actual-page :profile) (= sub-page :notifications)) :profile-notifications
        (and (= actual-page :profile) (= sub-page :documents)) :profile-documents
        (and (= actual-page :profile) (= sub-page :wanado)) :profile-wanado
        (and (= actual-page :profile) (= sub-page :events)) :profile-events
        (and (= actual-page :profile) (= sub-page :devices)) :profile-devices
        (and (= actual-page :profile) (= sub-page :setup)) :profile-setup
        :else :profile
        ))))

(defn person-pane [!actual-user]
  [mui/grid
   {:container  true
    :direction  "row"
    :justify    "center"
    :alignItems "center"
    :spacing    2
    :style      {:marginTop "25px"}
    }

   [mui/grid
    {:container false
     :xl        6
     :lg        6
     :md        8
     :sm        12
     :xs        12
     :style     {:margin "12px 0 14px 0"}
     }
    [mui/paper {:class ""
                :style {:backgroundColor (txt/txt :style :main-color) :color "white"}}

     [mui/grid
      {:container  true
       :direction  "row"
       :justify    "center"
       :alignItems "center"
       :spacing    2
       }
      [mui/grid
       {:container false
        :lg        2
        :md        4
        :sm        4
        :xs        4
        :style     {:height "160px" :textAlign "center"}
        }
       [mui/avatar {:src   (cond
                             (:portrait-path-fst @!actual-user) (:portrait-path-fst @!actual-user)
                             :else "/custom/img/placeholder-md.png")
                    :style {:height "120px" :width "120px" :margin "15px 10px 10px 20px"}
                    }]
       ]

      [mui/grid
       {:container false
        :lg        8
        :xs        8                                        ;extra-small: 0px
        :style     {:padding "8px 0 4px 30px" :textAlign "left"}
        }

       [:h1 {:style {:margin "0px 0 6px 0"}} (txt/txt :profile "Ich im Team")]
       [:div {:style {:fontSize "24px"}}
        (str
          (get-in @!actual-user [:name :title]) " "
          (get-in @!actual-user [:name :first]) " "
          (get-in @!actual-user [:name :last])
          )
        ]
       [mui/button
        {
         :style     {:float "right" :margin "5px 40px 0 0"}
         :variant   "contained"
         :startIcon (r/as-element [edit])
         :onClick   #(set-profile-page :personal)
         }
        "Profil bearbeiten"]
       [:div {:style {:float "clear"}}]
       ]]]]]
  )


(defn options-pane [!actual-user]
  [mui/grid
   {:container  true
    :direction  "row"
    :justify    "center"
    :alignItems "center"
    :spacing    2
    :style      {:marginTop "0px"}
    }

   [mui/grid
    {:container false
     :xl        6
     :lg        6
     :md        8
     :sm        12
     :xs        12
     }
    [mui/paper {:class ""
                :style {:textAlign "left" :padding "25px"}}
     [mui/grid
      {:container  true
       :direction  "column"
       :justify    "space-between"
       :alignItems "flex-start"
       :spacing    1
       }

      (when (not (:profile-complete @!actual-user))
        [mui/grid
         {:container false
          :md        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :spacing   4
          }
         [mui/button
          {
           :style     {:justifyContent "left"}
           :fullWidth true
           :onClick   #(set-profile-page :personal)
           :variant   ""
           :startIcon (r/as-element [warning-two-tone {:fontSize "large" :style {:color "#e10032"}}])
           }
          "Profil nicht komplett! "]
         [mui/typography {:color "error" :variant "body2"} "Es fehlt: " (:profile-incomplete-hint @!actual-user)]
         [:br]])

      (when (not (:qualification-complete @!actual-user))
        [mui/grid
         {:container false
          :md        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :spacing   4
          }
         [mui/button
          {
           :style     {:justifyContent "left"}
           :fullWidth true
           :variant   ""
           :onClick   #(set-profile-page :qualifications)
           :startIcon (r/as-element [warning-two-tone {:fontSize "large" :style {:color "#e10032"}}])
           }
          "Qualifikationen nicht komplett! "]
         [mui/typography {:color "error" :variant "body2"} "Es fehlt: " (:qualification-incomplete-hint @!actual-user)]
         [:br]])

      (when (and
              (or
                (:request-catastrophy @!actual-user)
                (:request-lebensretter @!actual-user)
                (:request-nokat @!actual-user)
                )
              (not (:identity-confirmed @!actual-user)))
        [mui/grid
         {:container false
          :md        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :spacing   4
          }
         [mui/button
          {
           :style     {:justifyContent "left"}
           :fullWidth true
           :variant   ""
           :title     "Erforderlich für Lebensretter"
           :startIcon (r/as-element [warning-two-tone {:fontSize "large" :style {:color "#e10032"}}])
           :onClick   #(set-profile-page :documents)
           }
          "Identität bestätigen fehlt"]
         [:br]])

      (when (not (:email-confirmed @!actual-user))
        [mui/grid
         {:container false
          :md        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :spacing   4
          }

         [mui/button
          {
           :style     {:justifyContent "left"}
           :fullWidth true
           :variant   ""
           :title     "Erforderlich für vollständiges Profil"
           :startIcon (r/as-element [warning-two-tone {:fontSize "large" :style {:color "#e10032"}}])
           :onClick   #(a/verify-email)
           }
          "Email Validierung fehlt"]
         [:br]])

      (when (not (:hdy-valid @!actual-user))
        [mui/grid
         {:container false
          :md        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :spacing   4
          }
         [mui/button
          {
           :style     {:justifyContent "left"}
           :fullWidth true
           :variant   ""
           :title     "Erforderlich für vollständiges Profil"
           :startIcon (r/as-element [warning-two-tone {:fontSize "large" :style {:color "#e10032"}}])
           :onClick   #(a/verify-phone-number)
           }
          "SMS Validierung fehlt"]
         [:br]])


      [:br]
      [:hr]


      [mui/grid
       {:container false
        :md        6                                        ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        :spacing   4
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [person])
         ;:endIcon  (r/as-element [check-box])
         :onClick   #(set-profile-page :qualifications)
         }
        "Qualifikationen"]
       ]
      [mui/grid
       {:container false
        :md        6                                        ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        :spacing   4
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [rowing])
         ;:endIcon  (r/as-element [check-box])
         :onClick   #(set-profile-page :wanado)
         }
        "Was ich tun will"]
       ]




      [:br]
      [:hr]

      [mui/grid
       {:container false
        :md        12                                       ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        :spacing   4
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [notifications])
         :onClick   #(set-profile-page :documents)
         }
        "Meine Dokumente"]
       ]

      [mui/grid
       {:container false
        :md        12                                       ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        :spacing   4
        }
       [mui/button
        {
         :style     {:justifyContent "left" :text-align "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [notifications])
         :onClick   #(set-profile-page :notifications)
         }
        "Meine Benachrichtigungen / Informationen"]
       ]
      [mui/grid
       {:container false
        :md        6                                        ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        :spacing   4
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [event])
         :onClick   #(set-profile-page :events)
         }
        "Meine Einsätze"]
       ]



      [mui/grid
       {:container false
        :md        6                                        ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [devices])
         :onClick   #(set-profile-page :devices)
         }
        "Meine Geräte"]
       ]

      [:br]
      [:hr]

      [mui/grid
       {:container false
        :md        6                                        ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [lock])
         :onClick   #(a/change-password)
         }
        "Passwort ändern"]
       ]

      ;[mui/grid
      ; {:container false
      ;  :md 6  ;medium: 960px
      ;  :xs 12  ;extra-small: 0px
      ;  }
      ; [mui/button
      ;  {
      ;   :style {:justifyContent "left"}
      ;   :fullWidth true
      ;   :variant ""
      ;   :startIcon (r/as-element [settings])
      ;   :onClick  #(set-profile-page :setup)
      ;   }
      ;  "Einstellungen"]
      ; ]



      [mui/grid
       {:container false
        :md        6                                        ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [description])
         :onClick   #(a/set-page :dsgvo :landing)
         }
        "Datenschutz"]
       ]



      [mui/grid
       {:container false
        :md        6                                        ;medium: 960px
        :xs        12                                       ;extra-small: 0px
        }
       [mui/button
        {
         :style     {:justifyContent "left"}
         :fullWidth true
         :variant   ""
         :startIcon (r/as-element [info])
         :onClick   #(a/set-page :impressum :landing)
         }
        "Impressum"]
       ]

      ]]]]
  )




(defn get-it []
  (let [!profile-state (r/cursor store/app-state [:profile-state])
        !actual-user (r/cursor store/app-state [:actual-user])]
    (bottom-bar/set-actions)
    [:div
     [person-pane !actual-user]
     [options-pane !actual-user]

     ]
    ))